import {t, UserFacingCatalogueError} from '../utils/catalogueUi';

/**
 * The BE refused to attach a created equipment item to one trim (spec 3.3, bug 2). The item stays
 * created; the message names the trim and the BE reason, and the dialog shows it inline. It is
 * `business`, so a toast of it offers no AI bug report.
 */
export class EquipmentAttachRefusedOnTrim extends UserFacingCatalogueError {
  constructor(name: string, trim: string, reason: string) {
    super(
      t(
        'entity.newVehicle.authoring.equipmentAttachRefusedOnTrim',
        '{name} was created, but {trim} refused it: {reason} Fix it on the Equipment by trim tab, then save again.',
        {name, trim, reason}
      )
    );
    this.name = 'EquipmentAttachRefusedOnTrim';
    this.errorOrigin = 'business';
  }
}
